import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { LogoIcon } from "@/components/Logo";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#f9f8f5] px-6 text-center text-[#202124]" data-testid="notfound-page">
      <SEO title="Page not found — Saans Wellness" description="The page you are looking for could not be found." path="/404" noindex />
      <LogoIcon size={64} arc="#1c1a17" sprout="#1f5d3a" />
      <h1 className="mt-6 font-display text-6xl text-[#202124]">404</h1>
      <p className="mt-3 font-serif text-2xl">This page took a deep breath and wandered off.</p>
      <p className="mt-2 max-w-md text-[#6b6a65]">The page you're looking for doesn't exist or has moved.</p>
      <Link to="/" data-testid="notfound-home"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#d46a1d] px-7 py-3.5 text-sm font-semibold text-white transition-transform hover:scale-[1.03]">
        Back to Home
      </Link>
    </div>
  );
}
